import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminDashboard } from '../models/admin.models';
import { ApiResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {
  private baseUrl = `${environment.apiBaseUrl}/admin/dashboard`;

  constructor(private http: HttpClient) {}

  getDashboardStats(): Observable<AdminDashboard> {
    return this.http.get<ApiResponse<AdminDashboard>>(this.baseUrl).pipe(
      map(res => res.data)
    );
  }
}
